import { useState, useCallback } from 'react';
import { managerService } from '../services/managerService';

export const useManager = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getDashboard = useCallback(async () => {
  setLoading(true);
  setError(null);
  try {
    const result = await managerService.getDashboard();
    // MODIFIEZ CETTE PARTIE :
    // Si l'API retourne directement les données, utilisez-les
    setData(result); // ← Directement result, pas result.data
    return { success: true, data: result };
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
    setError(errorMessage);
    return { success: false, message: errorMessage };
  } finally {
    setLoading(false);
  }
}, []);

  const getUserDetails = useCallback(async (userId) => {
    setLoading(true);
    setError(null);
    try {
      const result = await managerService.getUserDetails(userId);
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  const getTickets = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await managerService.getTickets(params);
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  const updateTicket = useCallback(async (ticketId, data) => {
    setLoading(true);
    setError(null);
    try {
      const result = await managerService.updateTicket(ticketId, data);
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  const verifyKYC = useCallback(async (userId, status, notes) => {
    setLoading(true);
    setError(null);
    try {
      const result = await managerService.verifyKYC(userId, { status, notes });
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  const processWithdrawal = useCallback(async (withdrawalId, action, transactionHash, notes) => {
    setLoading(true);
    setError(null);
    try {
      const result = await managerService.processWithdrawal(withdrawalId, action, transactionHash, notes);
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  const getAllUsers = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await managerService.getAllUsers(params);
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  const viewTransactions = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await managerService.viewTransactions(params);
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  // Fonction pour rafraîchir le dashboard
  const refreshDashboard = useCallback(async () => {
    return await getDashboard();
  }, [getDashboard]);

  return {
    loading,
    error,
    data,
    getDashboard,
    getUserDetails,
    getTickets,
    updateTicket,
    verifyKYC,
    processWithdrawal,
    getAllUsers,
    viewTransactions,
    refreshDashboard
  };
};